import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { FilterService } from 'src/app/_shared/service/filter.service';
import { WorkspaceState } from '../../../_shared/state/workspace.state';
import { SearchState } from '../../state/search.state';

@Injectable({
  providedIn: 'root',
})
export class SearchBarFacade {
  queryParamsSubscription;
  onDestroyNotifier$ = new Subject();

  constructor(
    private searchState: SearchState,
    private workspaceState: WorkspaceState,
    private filterService: FilterService,
    private router: Router
  ) { }

  ngOnDestroy() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  setAddressObj(addressObj) {
    let formatted_address = '';
    if (addressObj && addressObj.formatted_address) {
      formatted_address = addressObj.formatted_address;
    } else if (addressObj && addressObj.searchAddress && addressObj.searchAddress.fullAddress) {
      formatted_address = addressObj.searchAddress.fullAddress;
    } else if (addressObj && addressObj.fullAddress) {
      formatted_address = addressObj.fullAddress;
    }
    this.setQueryParams(formatted_address);
    this.workspaceState.isSwitchedValue = false;
    this.filterService.saveFilterList();
  }

  setQueryParams(params: any) {
    const queryParams = {
      search: params,
    };
    this.router.navigate(['workspace/map'], {
      queryParams: queryParams,
      queryParamsHandling: 'merge',
      // replaceUrl: true,
      state: { skipUpdate: true },
    });
  }

  getFullAddress(): Observable<string> {
    return new Observable((observer) => {
      this.searchState.searchAddress$.subscribe((res: any) => {
        if (res) {
          this.dataLayerSetValue(res);
        }
        if (res && res.searchAddress && res.searchAddress.fullAddress) {
          observer.next(res.searchAddress.fullAddress);
        } else if (res && res.fullAddress) {
          observer.next(res.fullAddress);
        } else {
          observer.next('');
        }
      });
    });
  }

  dataLayerSetValue(res) {
    const dataLayerValue = {
      address: res.fullAddress,
      city: res.City,
      state: res.State,
      zip: res.PostalCode,
    };
    this.filterService.dataLayerFilterValue('propertySearch', dataLayerValue);
  }
}
